import { useState, useEffect } from 'react'
import { Slider } from '@mui/material';
import { Box, Stack } from '@mui/system';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import RotateRightIcon from '@mui/icons-material/RotateRight';
import Cropper, { type Area, type Point } from 'react-easy-crop'
import { getCroppedImg } from './cropperHelper';

interface ImageCropperProps {
    setImage: (file: File) => void,
    imagePreview: File,
    aspectRatio?: number
}

export const ImageCropper = ({
    setImage, imagePreview, aspectRatio
}: ImageCropperProps) => {

    const [imgUrl, setImgUrl] = useState('');
    const [crop, setCrop] = useState<Point>({ x: 0, y: 0 })
    const [zoom, setZoom] = useState(1)
    const [rotation, setRotation] = useState(0)
    const [croppedAreaPixels, setCroppedAreaPixels] = useState<Area | null>(null)

    function onCropComplete(_: Area, croppedPixels: Area) {
        setCroppedAreaPixels(croppedPixels)
        setCroppedImage();
    }

    async function setCroppedImage() {
        if (!croppedAreaPixels) {
            return
        }

        //setCroppedImage(await getCroppedImg(imgUrl, croppedAreaPixels, rotation))
        setImage(await getCroppedImg(imgUrl, croppedAreaPixels, rotation) as unknown as File)
    }

    const handleZoomChange = (event: Event, newValue: number | number[]) => {
        setZoom(newValue as number);
    };

    const handleRotationChange = (event: Event, newValue: number | number[]) => {
        setRotation(newValue as number);
    };

    useEffect(() => {
        setZoom(0.1);
        setImgUrl(URL.createObjectURL(imagePreview));
        setRotation(0.1);
        globalThis.setTimeout(() => {
            setZoom(1);
            setRotation(0);
        }, 100);

        return () => {
            URL.revokeObjectURL(imgUrl)
        }
        // Only add imagePreview else cuases too many rerenders
        // eslint-disable-next-line
    }, [imagePreview])

    return (
        <>
            <Box sx={{ height: '400px' }}>
                <Cropper
                    image={imgUrl}
                    crop={crop}
                    zoom={zoom}
                    rotation={rotation}
                    aspect={aspectRatio}
                    onCropChange={setCrop}
                    onCropComplete={onCropComplete}
                    onRotationChange={setRotation}
                    onZoomChange={setZoom}
                />
            </Box>
            <Box sx={{ width: '200px', margin: '10px auto' }}>
                <Stack spacing={2} direction="row" sx={{ mb: 1 }}>
                    <RemoveIcon />
                    <Slider value={zoom} onChange={handleZoomChange} defaultValue={1} step={0.1} min={0.1} max={1.9} />
                    <AddIcon />
                </Stack>
                <Stack spacing={2} direction="row" sx={{ mb: 1 }}>
                    <RotateLeftIcon />
                    <Slider value={rotation} onChange={handleRotationChange} defaultValue={0} step={1} min={-180} max={180} />
                    <RotateRightIcon />
                </Stack>
            </Box>
        </>
    )
}
